import { lireBibliotheque, trouverFiche, lireResultFin, estRetiree, choisirContenuBilan, parcoursTermine } from './contenuBilan'
import { moduleTermine } from '../Certificat/moduleTermine'
import { categorieMasquee } from '../../../utils/categoriesMasquees'
import BIBLIOTHEQUE_JSON from './bibliotheque_18_competences.json'

/* ⛔ BILAN SOFT SKILLS, ETAPE 2 : LES DONNEES REELLES DE L'APPRENANT
   (07/10/2026). Tout se calcule dans le navigateur, a partir de ce que le
   tableau de bord a deja (`currentUser`, `actPlan`) : aucun appel serveur.

   POUR QUI : les apprenants (type « student »), jamais les candidats THE
   SCAN.
   ⛔ 08/10/2026 (Nawal) : PAR DEFAUT DANS TOUT PARCOURS NON CERTIFIANT. La
   ligne existe des que le plan contient au moins un module apres
   l'icebreaker, sans rien regler dans les modules (le module de demo 147
   n'avait aucune competence cochee dans ses reglages, et le bilan ne
   s'affichait pas). Les scores viennent des resultats des modules termines,
   comme avant.
   PARCOURS CERTIFIANT (certification du groupe activee, meme regle que
   « Ma certification », utils/accesCertification.js) : regle d'avant,
   inchangee. La ligne n'existe que si un module mesure une competence du
   referentiel : une entree de son `softSkillsFromContent` (le champ
   `softSkills` du module : { key, value }) qui n'est pas « non » et qui a
   une fiche dans la bibliotheque des 18.

   LES SCORES : les `resultFin` des modules TERMINES du plan (isDone et 100 %,
   comme le certificat), icebreaker exclu. Seules comptent les 18 competences
   du referentiel (une fiche) : multitache et autonomie, les echelles T1 et
   T2, la satisfaction, master et glbMaster n'en sont jamais ; une categorie
   que le module marque « non » non plus. Une competence mesuree dans
   plusieurs modules : celle du DERNIER module termine (date de fin `doneAt`,
   sinon l'ordre du plan).

   ETATS DE LA LIGNE :
     - « verrouillee » : parcours pas termine (icebreaker et tous les modules,
       isDone et 100 %) ;
     - « incomplete » : parcours termine, mais moins de 3 competences du
       referentiel mesurees (message neutre) ;
     - « disponible » : le bilan peut s'ouvrir.

   « DÉLIVRÉ LE » : le `doneAt` le plus recent des modules du plan, sinon la
   date du jour (juste apres la fin, `doneAt` n'arrive qu'au rechargement).
   LE PARCOURS : le `titrePlan` du premier groupe de l'apprenant s'il arrive
   dans ses donnees ; sinon rien (aucune valeur inventee). */

export const BIBLIOTHEQUE = lireBibliotheque(BIBLIOTHEQUE_JSON)

/* 07/10/2026 : une categorie masquee (« Masquer », display) est ecartee comme
   une categorie marquee « non » (voir utils/categoriesMasquees.js). */
const marquesNon = (module) => new Set((module?.softSkillsFromContent || [])
  .filter((s) => categorieMasquee(s)).map((s) => String(s.key)))

export const planMesureDesCompetences = (actPlan, bibliotheque = BIBLIOTHEQUE) => Array.isArray(actPlan)
  && actPlan.slice(1).some((m) => (m?.softSkillsFromContent || [])
    .some((s) => s && !categorieMasquee(s) && !estRetiree(s.key) && trouverFiche(bibliotheque, s.key)))

/* au moins un module apres l'icebreaker (actPlan[0]) */
const planAvecModule = (actPlan) => Array.isArray(actPlan)
  && actPlan.slice(1).some((m) => m && m.id !== null && m.id !== undefined)

const instant = (d) => {
  if (!d) return NaN
  const t = new Date(d).getTime()
  return Number.isFinite(t) ? t : NaN
}

/* les modules termines, du plus ancien au plus recent */
const modulesTermines = (actPlan) => (Array.isArray(actPlan) ? actPlan.slice(1) : [])
  .map((m, i) => ({ m, i, t: instant(m?.doneAt) }))
  .filter(({ m }) => moduleTermine(m) && lireResultFin(m?.resultFin))
  .sort((a, b) => ((Number.isFinite(a.t) ? a.t : -Infinity) - (Number.isFinite(b.t) ? b.t : -Infinity)) || (a.i - b.i))

/* les seuils du Diagnostic d'une categorie, du plus haut au plus bas */
const seuilsDuModule = (module, cle) => {
  const s = (module?.seuils || []).find((x) => x?.key === cle)
  const v = (s?.value?.seuil || []).map((x) => Number(x?.seuil)).filter(Number.isFinite)
  return v.length ? v.sort((a, b) => b - a) : undefined
}

export const scoresDuParcours = (actPlan, bibliotheque = BIBLIOTHEQUE) => {
  const scores = {}
  const seuils = {}
  modulesTermines(actPlan).forEach(({ m }) => {
    const r = lireResultFin(m.resultFin)
    const non = marquesNon(m)
    Object.entries(r).forEach(([cle, v]) => {
      const score = Number(v?.score)
      if (!Number.isFinite(score) || typeof v?.score === 'boolean' || v?.score === '' || v?.score === null) return
      if (cle === 'master' || cle === 'glbMaster' || estRetiree(cle) || non.has(cle)) return
      const fiche = trouverFiche(bibliotheque, cle)
      if (!fiche) return
      scores[fiche.cle] = score
      const s = seuilsDuModule(m, cle)
      if (s) seuils[fiche.cle] = s
      else delete seuils[fiche.cle]
    })
  })
  return { scores, seuils }
}

export const dateDuBilan = (actPlan, maintenant = new Date()) => {
  const t = (Array.isArray(actPlan) ? actPlan : []).map((m) => instant(m?.doneAt)).filter(Number.isFinite)
  return t.length ? new Date(Math.max(...t)) : maintenant
}

/* 08/10/2026 (Hicham) : `titrePlan` arrive bien dans `currentUser.groupes`,
   mais `groupes[0]` peut etre le groupe admin (id 1, « Plan Admin ») pour un
   compte de test. On prend le groupe du parcours : celui dont l'id figure dans
   les lignes du plan (`groupeID`), sinon le premier groupe qui n'est pas le
   groupe admin. Rien de trouve : rien (aucune valeur inventee). */
const estGroupeAdmin = (g) => String(g?.id) === '1'
const titreRempli = (g) => typeof g?.titrePlan === 'string' && g.titrePlan.trim() !== ''
export const titreDuPlan = (currentUser, actPlan) => {
  const groupes = (Array.isArray(currentUser?.groupes) ? currentUser.groupes : []).filter((g) => g && !estGroupeAdmin(g))
  const idsDuPlan = new Set((Array.isArray(actPlan) ? actPlan : []).map((m) => m?.groupeID).filter((id) => id !== null && id !== undefined).map(String))
  const g = groupes.find((x) => idsDuPlan.has(String(x.id)) && titreRempli(x)) || groupes.find(titreRempli)
  return g ? g.titrePlan.trim() : ''
}

export const etatDuBilan = ({ currentUser, actPlan, public: pub = 'etudiant', bibliotheque = BIBLIOTHEQUE, maintenant = new Date(), parcoursCertifiant = false }) => {
  const parcoursConcerne = parcoursCertifiant ? planMesureDesCompetences(actPlan, bibliotheque) : planAvecModule(actPlan)
  const visible = currentUser?.type === 'student' && parcoursConcerne
  if (!visible) return { visible: false, etat: null, donnees: null }
  if (!parcoursTermine(actPlan)) return { visible: true, etat: 'verrouillee', donnees: null }
  const { scores, seuils } = scoresDuParcours(actPlan, bibliotheque)
  const contenu = choisirContenuBilan({ scores, seuils, bibliotheque, public: pub })
  if (!contenu) return { visible: true, etat: 'incomplete', donnees: null }
  return {
    visible: true,
    etat: 'disponible',
    donnees: {
      prenomNom: String(currentUser?.name || '').trim(),
      nomParcours: titreDuPlan(currentUser, actPlan),
      contenu,
      dateDelivrance: dateDuBilan(actPlan, maintenant),
    },
  }
}
